type RawEnv = {
  VITE_ENV: string;
  VITE_isProduction: boolean;
  VITE_APP_NAME: string;
  VITE_BACKEND_URL: string;
  VITE_FRONTEND_URL: string;
  VITE_SERVER_FRONTEND_PORT: string;
  VITE_LOGTO_APP_ID: string;
  VITE_LOGTO_ENDPOINT: string;
  VITE_LOGTO_CALLBACK: string;
  VITE_LOGTO_RESOURCE: string;
  VITE_LOGTO_LOGOUT_URL: string;
  VITE_CUSTOM_ENVIRONMENT: string;
  VITE_PUBLIC_POSTHOG_KEY: string;
  VITE_PUBLIC_POSTHOG_HOST: string;
};

declare global {
  interface Window {
    env?: RawEnv;
  }
}

// Merge strategy: Vite defaults -> runtime overrides from /config/env.js
const env: RawEnv = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ...(import.meta as any).env,
  ...(typeof window !== "undefined" ? window.env : {}),
};

export const config = {
  isProduction: env.VITE_ENV === "production",
  APP_NAME: env.VITE_APP_NAME,
  BACKEND_URL: env.VITE_BACKEND_URL,
  FRONTEND_URL: env.VITE_FRONTEND_URL,
  SERVER_FRONTEND_PORT: env.VITE_SERVER_FRONTEND_PORT,
  LOGTO_APP_ID: env.VITE_LOGTO_APP_ID,
  LOGTO_ENDPOINT: env.VITE_LOGTO_ENDPOINT,
  LOGTO_CALLBACK: env.VITE_LOGTO_CALLBACK,
  LOGTO_RESOURCE: env.VITE_LOGTO_RESOURCE,
  LOGTO_LOGOUT_URL: env.VITE_LOGTO_LOGOUT_URL,
  CUSTOM_ENVIRONMENT: env.VITE_CUSTOM_ENVIRONMENT,
  POSTHOG_KEY: env.VITE_PUBLIC_POSTHOG_KEY,
  POSTHOG_HOST: env.VITE_PUBLIC_POSTHOG_HOST,
} as const;

export type AppConfig = typeof config;
export default config;
